export default "/images/check.svg?b977756b63fe01a9ce7bb0f358e6ddc8";